export enum ESignTypes {
  SIGN_UP = 'SIGN_UP',
  LOGIN = 'LOGIN'
}

export enum ESignMethods {
  CREDENTIALS = 'CREDENTIALS',
  GOOGLE = 'GOOGLE'
}
